
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__getValidation, FormState__startLoading, FormState__setValidation, FormState_get_empty, FormState_$reflection } from "../Shared/Shared.js";
import { unit_type, union_type, record_type, bool_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_none, Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../Communication.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../public/assets/icons/Calendar_Warning.svg";
import { TextValue, PageHeader } from "../Components/Text.js";
import { useAuth } from "react-oidc-context";
import { Button, TextButton } from "../Components/Button.js";
import { redirectUri } from "../AuthRedirect.js";
import { ContactPanels } from "../OnboardingHub/ContactGuide.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

class State extends Record {
    constructor(FormState, ActivationSent) {
        super();
        this.FormState = FormState;
        this.ActivationSent = ActivationSent;
    }
}

function State_$reflection() {
    return record_type("AccountBlocked.View.State", [], State, () => [["FormState", FormState_$reflection()], ["ActivationSent", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ResendActivation", "ResendSucceeded", "ResendFailed"];
    }
}

function Msg_$reflection() {
    return union_type("AccountBlocked.View.Msg", [], Msg, () => [[], [], []]);
}

const resendActivationCmd = Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
    const pr = response.arrayBuffer();
    return pr.then((blob) => {
        Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), unit_type);
    });
})))), ["/api/customer/resend-activation", ""], () => (new Msg(1, [])), (_arg_1) => (new Msg(2, [])));

function init() {
    return [new State(FormState_get_empty(), false), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(FormState_get_empty(), true), Cmd_none()];
        case 2:
            return [new State(FormState__setValidation(FormState_get_empty(), "global", "account_blocked.not_activated_resend_failed"), state.ActivationSent), Cmd_none()];
        default:
            return [new State(FormState__startLoading(state.FormState), state.ActivationSent), resendActivationCmd];
    }
}

function AccountInfoContainer(props) {
    let elems_7, elems_6, elems, elems_1, elems_5, elems_4, elems_2, elems_3;
    const t = useTranslation()[0];
    const phoneNumber = t("global.phone_number");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "justify-center", "content-center", "bg-background"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "max-w-lg", "my-auto", "p-6", "flex", "flex-col", "border", "border-border", "rounded-md", "bg-[#FFFFFF]"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "w-24", "h-24", "mb-4"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mb-5", "mt-8"])], (elems_1 = [createElement(PageHeader, {
        Text: props.Header,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "mx-auto", "mb-5"])], (elems_5 = [createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: props.Text,
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("account_blocked.contact_question"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-2"])], (elems_4 = [reactElement("div", {
        className: join(" ", ["font-semibold"]),
        children: t("user.phone_number"),
    }), reactElement("div", createObj(singleton((elems_2 = [reactElement("a", {
        href: concat("tel:", ...phoneNumber),
        children: phoneNumber,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", {
        className: join(" ", ["font-semibold"]),
        children: t("general.email"),
    }), reactElement("div", createObj(singleton((elems_3 = [reactElement("a", {
        href: "mailto:support@inventory-one.com",
        children: "support@inventory-one.com",
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function TestphaseEnd(props) {
    let elems_3, elems_2, elems_1, elems;
    const t = useTranslation()[0];
    const auth = useAuth();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-background", "h-full", "overflow-y-auto"])], (elems_3 = [reactElement("div", createObj(ofArray([["style", {
        maxWidth: 1180,
        margin: (0 + "px ") + "auto",
        paddingTop: 48,
        paddingBottom: 48,
        paddingLeft: 24,
        paddingRight: 24,
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        marginBottom: 40,
        paddingTop: 24,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 24 + "px ",
    }], (elems_1 = [reactElement("div", createObj(singleton((elems = [reactElement("h1", {
        style: {
            fontSize: 28 + "px",
            fontWeight: 600,
            color: "#14181B",
            margin: ((((((0 + "px ") + 0) + "px ") + 12) + "px ") + 0) + "px",
            "letter-spacing": "-0.02em",
        },
        children: t("account_blocked.test_phase_end_heading"),
    }), reactElement("p", {
        style: {
            fontSize: 15 + "px",
            color: "#6B7280",
            lineHeight: 1.6,
            margin: 0,
            maxWidth: 600,
        },
        children: t("account_blocked.test_phase_end_description"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])))), createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("navbar.logout"),
        OnClick: () => {
            auth.removeUser();
            auth.signoutRedirect({
                post_logout_redirect_uri: redirectUri(),
            });
            props.OnLogout();
        },
        TestId: "test-phase-end-logout",
        Variant: "redButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(ContactPanels, null)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function AccountCanceled() {
    const t = useTranslation()[0];
    return createElement(AccountInfoContainer, {
        Header: t("account_blocked.account_canceled_header"),
        Text: t("account_blocked.account_canceled_info_text"),
    });
}

export function AccountNotActivated() {
    let elems_8, elems_7, elems, elems_1, elems_6;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_1[0];
    const phoneNumber = t("global.phone_number");
    const buttonState = (state_1.FormState.IsLoading ? true : state_1.ActivationSent) ? "disabled" : "enabled";
    const buttonLabel = state_1.FormState.IsLoading ? t("account_blocked.not_activated_resend_sending") : (state_1.ActivationSent ? t("account_blocked.not_activated_resend_sent") : t("account_blocked.not_activated_resend_button"));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "justify-center", "content-center", "bg-background"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "max-w-lg", "my-auto", "p-6", "flex", "flex-col", "border", "border-border", "rounded-md", "bg-[#FFFFFF]"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "w-24", "h-24", "mb-4"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mb-5", "mt-8"])], (elems_1 = [createElement(PageHeader, {
        Text: t("account_blocked.not_activated_header"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "mx-auto", "mb-5"])], (elems_6 = toList(delay(() => append(singleton_1(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("account_blocked.not_activated_info_text"),
    })), delay(() => {
        let elems_2;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mx-auto"])], (elems_2 = [createElement(Button, {
            ComponentState: buttonState,
            Label: buttonLabel,
            OnClick: () => {
                patternInput_1[1](new Msg(0, []));
            },
            TestId: "account-not-activated-resend",
            Variant: "primary",
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(state_1.FormState, t, "global"), (matchValue == null) ? singleton_1(defaultOf()) : singleton_1(createElement(TextValue, {
                FontWeight: "normal",
                TestId: "account-not-activated-resend-failed",
                Text: matchValue,
            }))), delay(() => append(singleton_1(createElement(TextValue, {
                FontWeight: "normal",
                TestId: "",
                Text: t("account_blocked.contact_question"),
            })), delay(() => {
                let elems_5, elems_3, elems_4;
                return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-2"])], (elems_5 = [reactElement("div", {
                    className: join(" ", ["font-semibold"]),
                    children: t("user.phone_number"),
                }), reactElement("div", createObj(singleton((elems_3 = [reactElement("a", {
                    href: concat("tel:", ...phoneNumber),
                    children: phoneNumber,
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])))), reactElement("div", {
                    className: join(" ", ["font-semibold"]),
                    children: t("general.email"),
                }), reactElement("div", createObj(singleton((elems_4 = [reactElement("a", {
                    href: "mailto:support@inventory-one.com",
                    children: "support@inventory-one.com",
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
            }))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

